<h1 mat-dialog-title>{{ config.title }}</h1>
<div mat-dialog-content>
  <form [formGroup]="form" novalidate>
    <mat-checkbox *ngIf="config.showFlagToggle" [formControlName]="flagControlKey">
      {{ config.flagToggleLabel }}
    </mat-checkbox>

    <div *ngIf="isNameVisible">
      <mat-form-field appearance="outline" class="saved-filter-dialog__field">
        <mat-label>{{ config.nameLabel }}</mat-label>
        <input matInput [formControlName]="nameControlKey" />
      </mat-form-field>
    </div>
  </form>
</div>
<div mat-dialog-actions class="saved-filter-dialog__actions">
  <button mat-stroked-button color="primary" (click)="onCancel()">{{ config.cancelButtonLabel }}</button>
  <button mat-flat-button color="primary" (click)="onSave()" cdkFocusInitial>{{ config.saveButtonLabel }}</button>
</div>
